import React from 'react';
import CommonTooltip from '../common-tooltip/CommonTooltip';
import Icon from '../../icons/Icon';
import { ICONS } from '../../icons';

import './CommonTip.scss';

function CommonTip({ tip }) {
  return (
    <CommonTooltip title={tip}>
      <span>
        <Icon icon={ICONS.Info} disableCommonStyles disableCommonColors className='common-tip_icon' />
      </span>
    </CommonTooltip>
  );
}

export default CommonTip;
